import { InfluencerProfileAudience, InfluencerProfileAudienceProps } from '../shared';

type InfluencerFacebookProfileAudienceProps = InfluencerProfileAudienceProps;

export const InfluencerFacebookProfileAudience = (props: InfluencerFacebookProfileAudienceProps) => (
  <InfluencerProfileAudience {...props} />
);
